import React from 'react'
import { graphql } from 'gatsby'

import Layout from '../Layout'
import SEO from '../components/SEO'
import OneColumn from '../components/OneColumn'

import PromotionsList from '../components/PromotionsList'
import Paragraph from '../components/Paragraph'

const PromotionsPage = ({ data }) => {

  return (
    <Layout>
      <SEO title="S&S Hospitality | Promotions" canonical="https://www.sandshospitality.com/promotions/" description='Exclusive dining events and promotions at Hong Kong’s top restaurants, bars and rooftops. Best set lunch, buffet, all-you-can eat, brunch. Indian, French, Italian, Steakhouse, Argentinian and Brazilian and Asian cuisines. ' />
      <OneColumn>
        <h1 class="page-header">What's on</h1>
        <Paragraph>Find out our promotions and best offers</Paragraph>
        <PromotionsList promotionsList={data.allStrapiPromotions.edges} />
      </OneColumn>
    </Layout>
  )
}

export const pageQuery = graphql`
  query PromotionsPageQuery {
    allStrapiPromotions(limit: 12, sort: { fields: startDate, order: DESC }) {
      edges {
        node {
          id
          name
          poster {
            childImageSharp {
              fluid {
                src
              }
            }
          }
          startDate
          endDate
          restaurants {
            Name
          }
        }
      }
    }
  }
`

export default PromotionsPage
